let APPLICATION_NAME = 'SACHSO_DEV';

let MODULE_ID = '3D637D13-634F-46F1-90C1-553294758898';

// Notification
let urlSendNotification = 'https://fcm.googleapis.com/fcm/send';
let serverKeyNotification = 'key=AAAA4gpWDCc:APA91bEFvJE3fzk-5tGARYtjaq_66cjzcxWnSsr0wX6-uO8v8zF3xkleZYXGkxkCOGOHKDNj6aGrsMEkZMyi0gtfuGKlqqiYfU6DsgK0gHjz-a5HExJPsrj7V5QIzni-9goMM3YkecDA';
let vapidKey = 'BGVbMT-2SJBKqF-spcp6nt-dHdigYQgvcg6nhDhrNDbAMNIcuyZ1wq8OcvhInRwMFB-u-USlV2YBwRuZQ6W2sBE';
const authorizationKey = 'Basic 12C1F7EF9AC8E288FBC2177B7F54D';

const CURRENT_DOMAIN = `${window.location.protocol}//${window.location.hostname}${window.location.port ? `:${window.location.port}` : ''}`;
const IS_SACHSO = window.location.hostname.includes('sachso');
const IS_LOCAL = window.location.hostname.includes('local');
const IS_PREVIEW_SACHSO = window.location.hostname.includes('preview');
const IS_VERCEL = window.location.hostname.includes('vercel.app');

// const IS_SACHSO = true;
// const IS_LOCAL = false;
// const IS_PREVIEW_SACHSO = false;

if (IS_SACHSO) {
  APPLICATION_NAME = 'SACHSO';
}

if (IS_LOCAL) {
  APPLICATION_NAME = 'SACHSO_DEV';
}
if (IS_PREVIEW_SACHSO) {
  APPLICATION_NAME = 'SACHSO_STAGE';
}

const phuongNamStyleButton = {
  backgroundImage: 'linear-gradient(to right, #209EDF, #2277DA)',
  color: 'white',
  padding: 10,
};

export { APPLICATION_NAME, CURRENT_DOMAIN, IS_PREVIEW_SACHSO, IS_SACHSO, IS_LOCAL, MODULE_ID, serverKeyNotification, urlSendNotification, vapidKey, authorizationKey, phuongNamStyleButton };
export default {
  APPLICATION_NAME,
  MODULE_ID,
  serverKeyNotification,
  urlSendNotification,
  vapidKey,
  IS_PREVIEW_SACHSO,
  IS_SACHSO,
  IS_LOCAL,
  IS_VERCEL,
  CURRENT_DOMAIN,
};
